import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: `[validateOnlyNumeric]`
})
export class ValidateOnlyNumericDirective implements AfterViewInit {
    constructor(private elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.elRef.nativeElement.innerText = "Allowed only numeric chars 0-9";
        this.elRef.nativeElement.classList.add('validate');
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/validate-only-numeric.directive.ts